/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IPromoOptionContainerData } from './promo-option-container.data';
import { IPromoOptionContainerProps } from './promo-option-container.props.autogenerated';
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { get } from 'lodash';
import { IModuleStateManager, IModuleStateProps } from '@msdyn365-commerce-modules/checkout-utilities';

export interface IPromoOptionContainerPropsExt extends IPromoOptionContainerProps<IPromoOptionContainerData>, IModuleStateProps {
    enableControl: boolean;
}

export interface IPromoOptionContainerViewProps extends IPromoOptionContainerProps<IPromoOptionContainerData> {
    items: IPromoOptionContainerItemProps[];
    moduleState: IModuleStateManager;
    promoOptionContainerModuleProps: IModuleProps;
}

export interface IPromoOptionContainerItemProps {
    id: string;
    itemProps: INodeProps;
    item: React.ReactNode;
}

/**
 *
 * PromoOptionContainer component
 * @extends {React.PureComponent<IPromoOptionContainerProps<IPromoOptionContainerData>>}
 */
export class PromoOptionContainer extends React.PureComponent<IPromoOptionContainerPropsExt> {
    public render(): JSX.Element | null {
        const items = this.getSlots();
        const viewProps: IPromoOptionContainerViewProps = {
            ...this.props,
            items: items.map((item: React.ReactNode) => {
                const childId = get(item, 'props.id') || '';
                return {
                    id: childId,
                    itemProps: {
                        className: ''
                    },
                    item
                };
            }),
            promoOptionContainerModuleProps: {
                moduleProps: this.props,
                className: this.props.config.className || 'gdn-promo-option-container'
            }
        };

        return this.props.renderView(viewProps);
    }

    private readonly getSlots = (): React.ReactNode[] => {
        const { slots } = this.props;

        const items: React.ReactNode[] = [];
        if (slots && slots.primary && slots.primary.length > 0) {
            items.push(...slots.primary);
        }

        return items;
    };
}

export default PromoOptionContainer;
